module.exports = __webpack_public_path__ + "img/logo.138f41ce.png";